import { Paper, Stack, styled, Typography } from "@mui/material";
import { orange } from "../../theme/designColors";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { BodyTextM, HeadingM, HeadingXL, HeadingXS } from "../Typography";

export const InvestmentProfileWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        gap: theme.spacing(5),
        width: "100%",
    }),
);

export const InvestmentProfileHeadingXL = styled(HeadingXL)(({ theme }) =>
    theme.unstable_sx({
        m: theme.spacing(0),
        width: "100%",
    }),
);

export const InvestmentProfileHeadingXS = styled(
    HeadingXS,
    styledOmitPropsOptions,
)<{
    $selected?: boolean;
    $withoutMargin?: boolean;
}>(({ theme, $selected, $withoutMargin }) =>
    theme.unstable_sx({
        ...($selected && {
            color: theme.palette.primary.main,
        }),
        ...($withoutMargin && {
            m: theme.spacing(0),
        }),
    }),
);

export const InvestmentProfileProfilesStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.spacing(4),
        width: "100%",
    }),
);

export const InvestmentProfileTypography = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
    }),
);

export const InvestmentProfileFundsAndStrategiesStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "start",
        gap: theme.spacing(4),
        width: "100%",
    }),
);

export const InvestmentProfileStrategiesStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: { xs: "100%", md: "40%" },
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
        pb: theme.spacing(4),
    }),
);

export const InvestmentProfileFundsStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: { xs: "100%", md: "40%" },
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
        pb: theme.spacing(4),
    }),
);

export const InvestmentProfileFundPaper = styled(
    Paper,
    styledOmitPropsOptions,
)<{ $selected?: boolean }>(({ theme, $selected }) =>
    theme.unstable_sx({
        p: theme.spacing(4),
        backgroundColor: $selected ? orange["000"] : theme.palette.background.paper,
        ...($selected && { border: `1px solid ${theme.palette.primary.main}` }),
    }),
);

export const InvestmentProfileProfilePaper = styled(
    Paper,
    styledOmitPropsOptions,
)<{ $selected?: boolean }>(({ theme, $selected }) =>
    theme.unstable_sx({
        p: theme.spacing(4),
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: { xs: "100%", md: "30%" },
        backgroundColor: $selected ? theme.palette.grey[50] : theme.palette.background.paper,
        ...($selected && { border: `1px solid ${theme.palette.grey[500]}` }),
    }),
);

export const InvestmentProfileHeadingM = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        m: theme.spacing(0),
    }),
);

export const BodyTextBold = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        m: theme.spacing(0),
        fontWeight: "bold",
    }),
);
